import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { onChangeInputEvent, onFocusSelectEvent } from '~/types/types';
import { Button, Stack } from '@qred/components-library';
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form';
import AMLFields from '../AMLFields/AMLFields';
import { ICardOfferApplicant } from '~/interfaces/cardOffer';
import { updateApplicant } from '~/store/slices/cardOffer.slice';
import { trackCardOfferActions } from '~/store/actions/analyticsActions';

interface ApplicantProps {
  applicant: ICardOfferApplicant;
  onBlur: (name: onChangeInputEvent | onFocusSelectEvent | string) => void;
}

const Applicant = ({ applicant, onBlur }: ApplicantProps) => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();

  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const formMethods = useForm<ICardOfferApplicant>({
    defaultValues: applicant,
    mode: 'onTouched',
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = formMethods;

  const saveApplicant: SubmitHandler<ICardOfferApplicant> = (formData) => {
    dispatch(updateApplicant(formData));

    dispatch(
      trackCardOfferActions({
        actionName: 'edit_applicant_save_button_pressed',
      })
    );
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(saveApplicant)}>
        <Stack>
          <AMLFields trackFieldChange={onBlur} />
          <Stack align="center">
            <Button
              variant="secondary"
              data-cy="save_signer_button"
              fullWidth={mobile}
              size="md"
              type="submit"
              disabled={isSubmitting || isSubmitSuccessful}
            >
              {translate('Save')}
            </Button>
          </Stack>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default Applicant;
